const pagesIndividualClockingCorrectionEn = {
  batchSubmit: 'Batch Submit',
  bulk: {
    apply: 'Apply to selected',
    break: 'Break',
    clearSelection: 'Clear selection',
    clockIn: 'Clock-in',
    clockOut: 'Clock-out',
    reset: 'Reset selected',
    selected: '{{num}} selected'
  },
  description: 'Correct your clock-in, clock-out, and break times, then submit them in one batch.',
  editedCount: '{{num}} edited',
  empty: 'Select a period to correct.',
  emptyMissing: 'No missing punches this month.',
  emptyPeriod: 'No attendance records for this month.',
  filter: {
    missingOnly: 'Missing punch only ({{num}})'
  },
  period: {
    label: '{{year}}/{{month}}',
    nextAria: 'Next month',
    prevAria: 'Previous month'
  },
  reasonPlaceholder: 'Reason (optional)',
  submitDialog: {
    message: 'Submit {{num}} time clock correction(s)?',
    reasonLabel: 'Reason (optional)',
    submitting: 'Submitting…',
    title: 'Confirm submission'
  },
  submitErrorDescription: 'Could not submit your corrections. Please try again.',
  submitErrorTitle: 'Submission failed',
  submitSuccessDescription: 'Submitted {{num}} time clock correction(s) to HR.',
  submitSuccessTitle: 'Submitted',
  title: 'Time Clock Correction Request'
};
export default pagesIndividualClockingCorrectionEn;